// pipe (info tips / chrome gating): the ERP route surface as data — which workbench paths are
// ERP screens. The route TABLE stays the SSOT (workbench-router.ts tags every ERP route with
// erpScopedLazy); this list mirrors its first-segment prefixes for cheap pathname checks from
// chrome that must not import the router (module cycle). The erp-routes.spec.ts drift pin fails
// whenever the two disagree.
export const ERP_ROUTE_PREFIXES = [
  '/dashboard',
  '/records',
  '/ops',
  '/customers',
  '/sites',
  '/refining',
  '/comms',
  '/agreements',
  '/inbound',
  '/work',
  '/director',
  '/qms',
  '/sales',
  '/listings',
  '/reports',
  '/me',
  '/ask',
  // Floor stations (Task 0): the four operations stations live under the existing '/ops' prefix;
  // invoicing and settlement is its own family.
  '/finance',
] as const;

/** True when a workbench pathname is an ERP screen (exact match or a segment under a prefix). */
export function isErpPath(pathname: string): boolean {
  return ERP_ROUTE_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
